// extracted by mini-css-extract-plugin
export default {"logoC":"Logo_logoC__IXhSo"};